export interface IMasterDataDeductionType {
  typeId: number;
  name: string;
  deductionTypeKey: string;
  categoryId: number | null;
  categoryName: string | null;
  parentId: number | null;
  parentName: string | null;
  helpText: string | null;
  metadata: unknown;
  subTypeCount: number;
  isLinked: boolean;
  createdAt: string | null;
  createdBy: number | null;
  updatedAt: string | null;
  updatedBy: number | null;
}

export class MasterDataDeductionType {
  private readonly _typeId: number;
  private readonly _name: string;
  private readonly _deductionTypeKey: string;
  private readonly _categoryId: number | null;
  private readonly _categoryName: string | null;
  private readonly _parentId: number | null;
  private readonly _parentName: string | null;
  private readonly _helpText: string | null;
  private readonly _metadata: unknown;
  private readonly _subTypeCount: number;
  private readonly _isLinked: boolean;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;
  private readonly _updatedAt: string | null;
  private readonly _updatedBy: number | null;

  constructor(props: IMasterDataDeductionType) {
    this._typeId = props.typeId;
    this._name = props.name;
    this._deductionTypeKey = props.deductionTypeKey;
    this._categoryId = props.categoryId;
    this._categoryName = props.categoryName;
    this._parentId = props.parentId;
    this._parentName = props.parentName;
    this._helpText = props.helpText;
    this._metadata = props.metadata;
    this._subTypeCount = props.subTypeCount;
    this._isLinked = props.isLinked;
    this._createdAt = props.createdAt;
    this._createdBy = props.createdBy;
    this._updatedAt = props.updatedAt;
    this._updatedBy = props.updatedBy;
  }

  get typeId(): number {
    return this._typeId;
  }
  get name(): string {
    return this._name;
  }
  get deductionTypeKey(): string {
    return this._deductionTypeKey;
  }
  get categoryId(): number | null {
    return this._categoryId;
  }
  get categoryName(): string | null {
    return this._categoryName;
  }
  get parentId(): number | null {
    return this._parentId;
  }
  get parentName(): string | null {
    return this._parentName;
  }
  get helpText(): string | null {
    return this._helpText;
  }
  get metadata(): unknown {
    return this._metadata;
  }
  get subTypeCount(): number {
    return this._subTypeCount;
  }
  get isLinked(): boolean {
    return this._isLinked;
  }
  get createdAt(): string | null {
    return this._createdAt;
  }
  get createdBy(): number | null {
    return this._createdBy;
  }
  get updatedAt(): string | null {
    return this._updatedAt;
  }
  get updatedBy(): number | null {
    return this._updatedBy;
  }

  static from(props: IMasterDataDeductionType): MasterDataDeductionType {
    return new MasterDataDeductionType(props);
  }

  static toJSON(entity: MasterDataDeductionType): IMasterDataDeductionType {
    return {
      typeId: entity.typeId,
      name: entity.name,
      deductionTypeKey: entity.deductionTypeKey,
      categoryId: entity.categoryId,
      categoryName: entity.categoryName,
      parentId: entity.parentId,
      parentName: entity.parentName,
      helpText: entity.helpText,
      metadata: entity.metadata,
      subTypeCount: entity.subTypeCount,
      isLinked: entity.isLinked,
      createdAt: entity.createdAt,
      createdBy: entity.createdBy,
      updatedAt: entity.updatedAt,
      updatedBy: entity.updatedBy,
    };
  }
}

export interface IMasterDataDeductionTypeDeleteResult {
  deletedCount: number;
  blockedCount: number;
  blockedIds: number[];
  message: string | null;
}
